import AxiosClient from "../../../services/axios.services";

class EmployeesVacationsServices {
  getEmployeesVacations = params =>
    AxiosClient.post("/api/app/Tiempos_empleado_resumen/", params);
  updateEmployeeHalfDays = (employeeId, data) =>
    AxiosClient.put(`/api/app/Funcional_Empleado_Dias_Descanso/${employeeId}/`, data, {
      headers: {
        "Content-Type": "application/json"
      }
    });
}

export default new EmployeesVacationsServices();